import Typography from '@mui/material/Typography';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { TargetingReadOnlyList } from '@openx/components-package/components/PackageDetails/sections/TargetingReadOnlyList';
import { packageToFormState } from '@openx/components-package/components/PackageForm/utils/formStateConverter';
import { useFilteredTargetingItems } from '@openx/components-package/utils/hooks/useFilteredTargetingItems';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { DealDetailsSectionProps } from '../../../types';
import { useDealContext } from '../../utils/context/DealContext';

export type TargetingSectionDeal = { package_uid?: string } & { name: string };

export function TargetingCriteriaDetailsSection<T extends TargetingSectionDeal>({
  deal,
  historyMode,
}: DealDetailsSectionProps<T>) {
  const { t } = useTranslation();
  const { usePackageFetch, isOa } = useDealContext();

  const { loading: pckgLoading, pckg } = usePackageFetch(deal);
  const packageState = useMemo(() => packageToFormState(pckg || {}), [pckg]);

  const targeting = useFilteredTargetingItems(packageState);

  if (pckgLoading) {
    return <Loader />;
  }

  /* Temp Workaround Till Deal ID Conversion */
  const packageName =
    isOa && historyMode
      ? (packageState.name ?? `Custom package for OpenAudience { deal: ${deal.name}}`)
      : packageState.name;

  return (
    <FormSection historyMode={historyMode} title={t('Targeting Criteria')}>
      <Typography data-test="package-name" variant={historyMode ? 'body1' : 'h3'} sx={{ overflowWrap: 'anywhere' }}>
        {`${t('Package')}: ${packageName}`}
      </Typography>
      <div data-test="targeting-settings">
        {!historyMode ? <TargetingReadOnlyList targeting={targeting} packageState={packageState} /> : null}
      </div>
    </FormSection>
  );
}
